// extracted by mini-css-extract-plugin
module.exports = {"bgText":"SocialBox_bgText__cYDaG"};